import { render, staticRenderFns } from "./vRelationTG.vue?vue&type=template&id=07e23fb9&"
import script from "./vRelationTG.vue?vue&type=script&lang=js&"
export * from "./vRelationTG.vue?vue&type=script&lang=js&"
import style0 from "./vRelationTG.vue?vue&type=style&index=0&id=07e23fb9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports